import _ from "lodash";
import { hmac } from '@noble/hashes/hmac';
import { sha256 } from '@noble/hashes/sha256';

function* byteGenerator({ serverKey, userSeed, cursor, mode }: {
  serverKey: Buffer,
  userSeed: Buffer,
  cursor: number,
  mode: "u16" | "u32" | "u64"
}) {
  let currentRound = Math.floor(cursor / 32);
  let currentRoundCursor = cursor;
  currentRoundCursor -= currentRound * 32;

  while (true) {

    const cursorSeed = new ArrayBuffer(8);
    const view = new DataView(cursorSeed);
    view.setBigUint64(0, BigInt(currentRound), false);

    const hasher = hmac.create(sha256, serverKey);
    hasher.update(userSeed)
    hasher.update(new Uint8Array(cursorSeed))

    const mac = hasher.digest();

    while (currentRoundCursor < 32) {
      if (mode == "u16") {
        yield Number(Buffer.from(mac.buffer).readUInt16LE(currentRoundCursor));
        currentRoundCursor += 2;
      } else if (mode == "u32") {
        yield Number(Buffer.from(mac.buffer).readUInt32LE(currentRoundCursor));
        currentRoundCursor += 4;
      } else if (mode == "u64") {
        yield Number(Buffer.from(mac.buffer).readBigUInt64LE(currentRoundCursor));
        currentRoundCursor += 8;
      }
    }
    currentRoundCursor = 0;
    currentRound += 1;
  }
}


export const getUint16 = ({ serverKey, userSeed, cursor, count }: { serverKey: Buffer, userSeed: Buffer, cursor?: number, count: number }) => {
  return byteGenerator({
    serverKey: serverKey,
    userSeed: userSeed,
    cursor: cursor || 0,
    mode: "u16"
  }).take(count).toArray();
};

export const getUint32 = ({ serverKey, userSeed, cursor, count }: { serverKey: Buffer, userSeed: Buffer, cursor?: number, count: number }) => {
  return byteGenerator({
    serverKey: serverKey,
    userSeed: userSeed,
    cursor: cursor || 0,
    mode: "u32"
  }).take(count).toArray();
};


export const getUint64 = ({ serverKey, userSeed, cursor, count }: { serverKey: Buffer, userSeed: Buffer, cursor?: number, count: number }) => {
  return byteGenerator({
    serverKey: serverKey,
    userSeed: userSeed,
    cursor: cursor || 0,
    mode: "u64"
  }).take(count).toArray();
};






export const convertUInt32ToFloats = (value: number) => {
  const bytes = Buffer.alloc(4);
  bytes.writeUInt32LE(value);

  let total = 0;
  for (let i = 0; i < 4; i++) {
    total += parseInt(bytes.toString('hex').substring(i * 2, i * 2 + 2), 16) / Math.pow(256, i + 1);
  }
  return total;
}



export const getRoundNumbers = (numbers: number[], max: number, dynamic_range: boolean) => {
  return numbers.map((item, index) => {
    const itemMax = dynamic_range ? max - index : max;
    return Math.floor(convertUInt32ToFloats(item) * itemMax);
  });
}